const formCompanion = {
  formId: "companion-location-form",
  formField: {
    jobName: {
      name: "jobName",
      label: "Job Name",
      type: "text",
    },
    jobCode: {
      name: "jobCode",
      label: "Job Code",
      type: "text",
    },
    propertyCode: {
      name: "propertyCode",
      label: "Property Code",
      type: "text",
      errorMsg: "Property code is required!",
    },
    inRoomDiningPropertyId: {
      name: "inRoomDiningPropertyId",
      label: "Property ID",
      type: "text",
      errorMsg: "Property code is required!",
    },
    inRoomDining: {
      name: "inRoomDining",
      label: "In-Room Dining",
    },

    company: {
      name: "company",
      label: "Company",
      type: "text",
    },
    system: {
      name: "system",
      label: "System",
      type: "text",
    },
    version: {
      name: "version",
      label: "Version",
      type: "text",
    },
    apikey: {
      name: "apikey",
      label: "API Key",
      type: "text",
    },
    url: {
      name: "url",
      label: "URL",
      type: "text",
      invalidMsg: "The URL must start with http or https!",
    },
    portalId: {
      name: "portalId",
      label: "Portal ID",
      type: "text",
    },
    diningId: {
      name: "diningId",
      label: "Dining ID",
      type: "text",
    },
    pmsType: {
      name: "pmsType",
      label: "PMS Type",
      type: "text",
      errorMsg: "Type is required!",
    },
    pmsPropertyId: {
      name: "pmsPropertyId",
      label: "Property Id *",
      type: "text",
      errorMsg: "Property Id is required!",
    },
    authValue: {
      name: "authValue",
      label: "Auth Value",
      type: "text",
    },
    clientID: {
      name: "clientID",
      label: "Client ID *",
      type: "text",
      errorMsg: "Client ID is required!",
    },
    clientSecret: {
      name: "clientSecret",
      label: "Client Secret *",
      type: "text",
      errorMsg: "Client Secret is required!",
    },
    propertyID: {
      name: "propertyID",
      label: "Property ID *",
      type: "text",
      errorMsg: "Property ID is required!",
    },
  },
};

export default formCompanion;
